import { LinkAcesso } from './LinkAcesso';

export default LinkAcesso;
